import { useEffect } from 'preact/hooks';
import type { SessionEndReason } from '../../core/session/session-client';
import { pendingWatch } from '../dev/watch';
import { useTranslator } from '../hooks/use-translator';
import { useBoot } from '../services';
import { PANEL_THEME } from '../game/panel-theme';

export function SessionEndedScreen(props: { reason: SessionEndReason }) {
  const { session: client } = useBoot();
  const translator = useTranslator();
  // A reset asked for by F4's «watch in god mode» (B131): straight on to the sign-in, which signs in.
  useEffect(() => {
    if (props.reason !== 'outdated' && pendingWatch()) client.acknowledgeEnd();
  }, [client, props.reason]);
  return (
    <main class="screen screen--centered" data-testid="session-ended" data-reason={props.reason}>
      <section class="panel panel--narrow" data-theme={PANEL_THEME} role="alert">
        <h1 class="panel__title">{translator.t('screens.sessionEnded.title')}</h1>
        <p>{translator.t(`screens.sessionEnded.${props.reason}`)}</p>
        <button
          type="button"
          class="button button--primary"
          onClick={() => {
            if (props.reason === 'outdated') globalThis.location.reload();
            else client.acknowledgeEnd();
          }}
        >
          {translator.t('screens.sessionEnded.backToSelect')}
        </button>
      </section>
    </main>
  );
}
